module.exports = __webpack_public_path__ + "static/media/profile-illustration-min.7bfc95a7.webp";